<template>
  <div class="card modal-overflow" style="box-shadow: none;">
    <div style="text-align: center">Loading {{ loadingProgressLoaded }} of {{ loadingProgress.total }} Tasks</div>
    <progress :percentage="loadingProgressPercent" style="width: 100%"></progress>
    <div style="text-align: center">
      <h6>{{ loadingProgress.message }}</h6>
    </div>
  </div>
</template>

<script>
import {Progress} from 'element-ui'
import Constants from 'src/utilities/constants'

export default {
  props: ['data'],
  components: {
    Progress
  },
  computed: {
    loadingProgress() {
      return this.$store.get('tasks/search/loadingProgress')
    },
    loadingProgressLoaded() {
      return this.$store.get('tasks/search/loadingProgress@loaded')
    },
    loadingProgressPercent() {
      return this.$store.get('tasks/search/loadingProgress@percent')
    },
  },
  data() {
    return {
      progress: 0
    }
  },
  watch: {
    loadingProgressPercent: {
      handler: function(progressPercent) {
        this.progress = progressPercent
        if (progressPercent === 100) {
          setTimeout(() => {
            this.$emit('close')
          }, Constants.TIME.MILLIS.ONE_SECOND)
        }
      }
    }
  }
}
</script>
